<template>
  <div class="compare-view">
    <header class="compare-view__header mb-2">
      <UiHeadline tag="h1" size="large" theme="primary" align="center">
        {{ $t("depotfinder.results.compare.headline") }}
      </UiHeadline>
    </header>

    <div class="compare-view__content flex-grid grid-pad flex-h-center">
      <div class="flex-grid__col c-6">
        <Card
          variant="current"
          :headline="subline"
          :title="activeDeposit.name"
          :benefits="activeDepositBenefits"
          :button="{
            theme: 'primary',
            size: 'medium',
            label: $t('depotfinder.results.compare.keep-model')
          }"
          @select="chooseCurrent()"
        >
          <template #footer>
            <p>
              <strong
                >{{ $t("depotfinder.results.headline-conditions") }}:</strong
              >
            </p>
            <ul class="list list--conditions">
              <li
                v-for="(item, index) in depositModelConditions(
                  activeDeposit.conditions
                )"
                v-html="item"
                :key="index"
              ></li>
            </ul>
            <small
              v-if="activeDeposit.smallprint"
              v-html="productSmallprint(activeDeposit.smallprint)"
            ></small>
          </template>
        </Card>
      </div>
      <div class="flex-grid__col c-6">
        <Card
          :headline="sublineAlternative"
          :title="alternativeDeposit.name"
          :benefits="alternativeDepositBenefits"
          :button="{
            theme: 'secondary',
            variant: 'outline',
            size: 'medium',
            label: $t('depotfinder.results.compare.change-model')
          }"
          :isRecommended="alternativeDepositName == recommendedDeposit"
          @select="chooseAlternative()"
        >
          <template #footer>
            <p>
              <strong
                >{{ $t("depotfinder.results.headline-conditions") }}:</strong
              >
            </p>
            <ul class="list list--conditions">
              <li
                v-for="(item, index) in depositModelConditions(
                  alternativeDeposit.conditions
                )"
                v-html="item"
                :key="index"
              ></li>
            </ul>
            <small
              v-if="alternativeDeposit.smallprint"
              v-html="productSmallprint(alternativeDeposit.smallprint)"
            ></small>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import UiHeadline from "./../components/Ui/Headline.vue";
import Card from "./Card.vue";
import { depositModelConditions } from "./../mixins/depositModelConditions.js";

export default {
  mixins: [depositModelConditions],
  components: {
    UiHeadline,
    Card
  },
  props: {
    activeDeposit: {
      type: Object,
      required: true
    },
    alternativeDeposit: {
      type: Object,
      required: true
    },
    activeDepositModel: {
      type: String,
      required: true
    },
    alternativeDepositName: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    activeDepositBenefits() {
      return this.getDepositBenefits(this.activeDeposit);
    },
    alternativeDepositBenefits() {
      return this.getDepositBenefits(this.alternativeDeposit);
    },
    recommendedDeposit() {
      return this.$store.getters.getRecommendedDeposit;
    },
    activeDepositTab() {
      return this.$store.getters.getActiveDepositTab;
    },
    subline() {
      let subline =
        this.activeDepositModel == this.recommendedDeposit
          ? "recommendation"
          : "current-selection";
      return this.$t(`depotfinder.results.compare.${subline}`);
    },
    sublineAlternative() {
      let subline =
        this.recommendedDeposit == this.alternativeDepositName
          ? "recommendation"
          : "alternative";
      return this.$t(`depotfinder.results.compare.${subline}`);
    }
  },
  methods: {
    getDepositBenefits(model) {
      let benefits = this.$t("depositBenefits");
      let depositBenefits = [];
      Object.keys(benefits).forEach(function(key) {
        if (model.benefits_compare) {
          if (model.benefits_compare[key]) {
            depositBenefits.push(benefits[key]);
          }
        } else {
          if (model.benefits && model.benefits[key]) {
            depositBenefits.push(benefits[key]);
          }
        }
      });
      return depositBenefits;
    },
    chooseCurrent() {
      this.$store.dispatch("updateView", {
        view: "compareView",
        payload: false
      });
      this.$store.dispatch("updateActiveDepositTab", this.activeDepositModel);
      this.$store.dispatch("updateActiveDeposit", this.activeDepositModel);
    },
    chooseAlternative() {
      this.$store.dispatch("updateActiveDeposit", this.activeDepositTab);
      this.$store.dispatch("updateView", {
        view: "compareView",
        payload: false
      });
    }
  }
};
</script>
